import axios from 'axios';
import type { IRecentSearchHistory } from '@bb/domain/dist/types';

const addAgentToHistory = async (agentId: string) => {
  const { data } = await axios.post<IRecentSearchHistory>(
    `/search/recents/agents/${agentId}`,
  );
  return data;
};

export default addAgentToHistory;
